export const isSSR = () => __SERVER__ ?? false;
// Reference: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/devloop/
export const getAggSubscriptionEndpoint = () =>
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
export const WS_CLIENT_KEEP_ALIVE = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
export const WS_CLIENT_RETRIES = 100;
